/* eslint-disable global-require */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './style.css';

const Button = ({
  btnStyle = 'btn btn-trp-primary',
  children,
  disabled = false,
  id = '',
  onClick = () => {},
  tabIndex = 0,
  ...otherAttributes
}) => {
  return (
    <button
      data-e2e={otherAttributes['data-e2e']}
      disabled={disabled}
      id={id}
      onClick={onClick}
      className={btnStyle}
      tabIndex={tabIndex}
      type="button"
      readOnly={disabled}
      {...otherAttributes}>
      {children}
      <style jsx>{styles}</style>
    </button>
  );
};

Button.propTypes = {
  btnStyle: PropTypes.string,
  disabled: PropTypes.bool
};

export default Button;
